import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';

import css from './OrderBreakdown.module.css';

const TIERED_LINE_ITEM_CODES = ['line-item/monthly', 'line-item/weekly', 'line-item/day'];

/**
 * Renders tiered pricing line items (monthly, weekly, day) with proper translations.
 *
 * @component
 * @param {Object} props
 * @param {Array} props.lineItems - The line items to render
 * @param {boolean} props.isProvider - Whether the provider is viewing
 * @param {Object} props.intl - The intl object
 * @returns {JSX.Element|null}
 */
const LineItemTieredPricingMaybe = props => {
  const { lineItems, isProvider, intl } = props;

  // Filter to tiered pricing line items only
  const allTieredItems = lineItems.filter(
    item => TIERED_LINE_ITEM_CODES.includes(item.code) && !item.reversal
  );

  const items = isProvider
    ? allTieredItems.filter(item => item.includeFor.includes('provider'))
    : allTieredItems.filter(item => item.includeFor.includes('customer'));

  if (items.length === 0) {
    return null;
  }

  const getTranslationId = code => {
    switch (code) {
      case 'line-item/monthly':
        return 'OrderBreakdown.lineItemMonthly';
      case 'line-item/weekly':
        return 'OrderBreakdown.lineItemWeekly';
      case 'line-item/day':
        return 'OrderBreakdown.lineItemDay';
      default:
        return null;
    }
  };

  return (
    <React.Fragment>
      {items.map((item, i) => {
        const translationId = getTranslationId(item.code);
        const quantity = item.quantity || 1;
        const formattedTotal = formatMoney(intl, item.lineTotal);

        const label = translationId ? (
          <FormattedMessage id={translationId} values={{ quantity }} />
        ) : (
          `${item.code} x ${quantity}`
        );

        return (
          <div key={`${i}-${item.code}`} className={css.lineItem}>
            <span className={css.itemLabel}>{label}</span>
            <span className={css.itemValue}>{formattedTotal}</span>
          </div>
        );
      })}
    </React.Fragment>
  );
};

export default LineItemTieredPricingMaybe;
